import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IxButton from '../../../basic/ix-button';
import CustomerValidate from '../registration-validation';

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  buttonGd: {
    marginBottom: '0.5em',
    '& button': {
      width: '100%'
    }
  },
  formFiledContainer: {
    paddingBottom: theme.spacing(2),
    '& .MuiBox-root': {
      height: '20vh',
      overFlowY: 'auto'
    }
  },
  orText: {
    color: 'rgb(127,129,149)',
    fontWeight: 500
  },
  buttonContainer: {
    paddingLeft: '16px',
    paddingRight: '16px',
    textAlign: 'center'
  }
}));

const renderField = ({
  handleClickShowPassword,
  input,
  label,
  isPassword,
  meta: { touched, invalid, error },
  ...custom
}) => {
  const opt = {};
  input.name === 'password' &&
    (opt.endAdornment = (
      <InputAdornment position='end'>
        <IconButton
          aria-label='toggle password visibility'
          onClick={handleClickShowPassword}
          // onMouseDown={handleMouseDownPassword}
          edge='end'
        >
          {isPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    ));

  return (
    <TextField
      variant='outlined'
      margin='normal'
      fullWidth
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      autoComplete={label}
      InputProps={opt}
      {...input}
      {...custom}
    />
  );
};

const SignInForm = props => {
  const { handleSubmit, touchedOnLoad, history } = props;
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const { t, i18n } = useTranslation();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box pl={2} pr={2} mt={-3} className={classes.formFiledContainer}>
        <Field name='userName' component={renderField} label={t('userName')+'*'} />

        <Field
          name='password'
          isPassword={showPassword}
          component={renderField}
          label= {t('Password')+'*'}
          type={showPassword ? 'text' : 'password'}
          handleClickShowPassword={handleClickShowPassword}
        />
      </Box>

      <Grid className={classes.buttonContainer}>
        <Grid
          className={classes.buttonGd}
          container
          justify='center'
          item
          direction='row'
        >
          <IxButton
            //onClick={() => redirectToMenu(history)}
            variant='contained'
            color='primary'
          >
            {t('log_in')}
          </IxButton>
        </Grid>
        <p className={classes.orText}>{t('or')}</p>
      </Grid>
    </form>
  );
};

export default reduxForm({
  form: 'SignInForm', //                 <------ same form name
  //destroyOnUnmount: false, //        <------ preserve form data
  //forceUnregisterOnUnmount: true // <------ unregister fields on unmount
  validate: CustomerValidate
})(SignInForm);
